module.exports = __webpack_public_path__ + "img/zztbg-3-en.72e6faaa.png";